<svg #svg class="stage-svg" [attr.viewBox]="'0 0 ' + VIEW_W + ' ' + VIEW_H"
     preserveAspectRatio="xMidYMid meet"
     (pointermove)="onMove($event)"
     (pointerup)="onUp($event)"
     (pointercancel)="onUp($event)"
     (pointerleave)="onUp($event)">

  <defs>
    <linearGradient id="bi-panel" x1="0" y1="0" x2="0.3" y2="1">
      <stop offset="0%" stop-color="#17293f" /><stop offset="60%" stop-color="#0d1a2c" /><stop offset="100%" stop-color="#07101d" />
    </linearGradient>
    <linearGradient id="bi-brass" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#ffe6a0" /><stop offset="45%" stop-color="#e8b556" /><stop offset="100%" stop-color="#a97e34" />
    </linearGradient>
    <!-- userSpaceOnUse: the beam goes perfectly horizontal at balance (zero-height
         bbox), which would make an objectBoundingBox gradient stroke vanish. -->
    <linearGradient id="bi-brass-h" gradientUnits="userSpaceOnUse" x1="262" y1="150" x2="738" y2="150">
      <stop offset="0%" stop-color="#b8863a" /><stop offset="35%" stop-color="#ffe6a0" /><stop offset="65%" stop-color="#e8b556" /><stop offset="100%" stop-color="#a97e34" />
    </linearGradient>
    <radialGradient id="bi-dish" cx="50%" cy="30%" r="80%">
      <stop offset="0%" stop-color="#ffe9b0" /><stop offset="55%" stop-color="#dca849" /><stop offset="100%" stop-color="#9a722e" />
    </radialGradient>
    <linearGradient id="bi-left" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#ffc196" /><stop offset="100%" stop-color="#dd6f31" />
    </linearGradient>
    <linearGradient id="bi-right" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stop-color="#9ff0dc" /><stop offset="100%" stop-color="#20a08f" />
    </linearGradient>
    <radialGradient id="bi-knob" cx="38%" cy="30%" r="72%">
      <stop offset="0%" stop-color="#ffffff" /><stop offset="45%" stop-color="#8ff0dc" /><stop offset="100%" stop-color="#1f9c8a" />
    </radialGradient>
    <filter id="bi-soft" x="-70%" y="-70%" width="240%" height="240%"><feGaussianBlur stdDeviation="9" /></filter>
  </defs>

  <!-- panel + motes -->
  <rect x="0" y="0" [attr.width]="VIEW_W" [attr.height]="VIEW_H" fill="url(#bi-panel)" />
  <g class="motes" fill="#bfe4ff">
    <circle cx="150" cy="120" r="2" /><circle cx="820" cy="90" r="1.6" /><circle cx="700" cy="200" r="1.8" />
    <circle cx="250" cy="260" r="1.5" /><circle cx="880" cy="300" r="2" /><circle cx="120" cy="360" r="1.6" />
  </g>

  <!-- ── Stand (fixed) ─────────────────────────────────────────────── -->
  <ellipse class="contact" cx="500" cy="470" rx="140" ry="16" filter="url(#bi-soft)" />
  <ellipse class="base-plate" cx="500" cy="462" rx="120" ry="19" />
  <ellipse class="base-top" cx="500" cy="456" rx="96" ry="13" />
  <path class="pedestal" d="M 458 456 Q 490 456 495 424 L 505 424 Q 510 456 542 456 Q 500 448 458 456 Z" />
  <rect class="column" x="489" y="150" width="22" height="278" rx="8" />
  <rect class="column-hi" x="493" y="156" width="4.5" height="266" rx="2" />
  <ellipse class="collar" cx="500" cy="300" rx="18" ry="6" />
  <ellipse class="collar" cx="500" cy="230" rx="15" ry="5" />

  <!-- ── Pans + weights (hang from the tilting beam) ───────────────── -->
  <g class="side">
    <line class="chain" [attr.x1]="beamLeft.x" [attr.y1]="beamLeft.y" [attr.x2]="panLeft.x - 42" [attr.y2]="panLeft.y - 10" />
    <line class="chain" [attr.x1]="beamLeft.x" [attr.y1]="beamLeft.y" [attr.x2]="panLeft.x + 42" [attr.y2]="panLeft.y - 10" />
    <!-- weight sitting in the dish -->
    <g class="weight" [attr.transform]="'translate(' + panLeft.x + ',' + panLeft.y + ')'">
      <path class="w-handle" d="M -13 -60 Q -15 -84 0 -84 Q 15 -84 13 -60" />
      <path class="w-body w-left" d="M -56 -6 L 56 -6 L 46 -56 Q 46 -62 40 -62 L -40 -62 Q -46 -62 -46 -56 Z" />
      <path class="w-hi" d="M -50 -12 L 50 -12 L 46 -24 L -46 -24 Z" />
      <text class="w-text" x="0" y="-30" text-anchor="middle" dominant-baseline="central">{{ fromLabel }}</text>
    </g>
    <path class="dish" [attr.d]="'M ' + (panLeft.x - 62) + ' ' + (panLeft.y - 8) + ' Q ' + panLeft.x + ' ' + (panLeft.y + 32) + ' ' + (panLeft.x + 62) + ' ' + (panLeft.y - 8) + ' Q ' + panLeft.x + ' ' + (panLeft.y + 5) + ' ' + (panLeft.x - 62) + ' ' + (panLeft.y - 8) + ' Z'" />
    <ellipse class="dish-rim" [attr.cx]="panLeft.x" [attr.cy]="panLeft.y - 8" rx="62" ry="11" />
  </g>

  <g class="side">
    <line class="chain" [attr.x1]="beamRight.x" [attr.y1]="beamRight.y" [attr.x2]="panRight.x - 42" [attr.y2]="panRight.y - 10" />
    <line class="chain" [attr.x1]="beamRight.x" [attr.y1]="beamRight.y" [attr.x2]="panRight.x + 42" [attr.y2]="panRight.y - 10" />
    <g class="weight" [class.win]="solvedState" [attr.transform]="'translate(' + panRight.x + ',' + panRight.y + ')'">
      <path class="w-handle" d="M -13 -60 Q -15 -84 0 -84 Q 15 -84 13 -60" />
      <path class="w-body w-right" d="M -56 -6 L 56 -6 L 46 -56 Q 46 -62 40 -62 L -40 -62 Q -46 -62 -46 -56 Z" />
      <path class="w-hi" d="M -50 -12 L 50 -12 L 46 -24 L -46 -24 Z" />
      <text class="w-text" x="0" y="-30" text-anchor="middle" dominant-baseline="central">{{ toLabel }}</text>
    </g>
    <path class="dish" [attr.d]="'M ' + (panRight.x - 62) + ' ' + (panRight.y - 8) + ' Q ' + panRight.x + ' ' + (panRight.y + 32) + ' ' + (panRight.x + 62) + ' ' + (panRight.y - 8) + ' Q ' + panRight.x + ' ' + (panRight.y + 5) + ' ' + (panRight.x - 62) + ' ' + (panRight.y - 8) + ' Z'" />
    <ellipse class="dish-rim" [attr.cx]="panRight.x" [attr.cy]="panRight.y - 8" rx="62" ry="11" />
  </g>

  <!-- ── Beam + pivot ──────────────────────────────────────────────── -->
  <line class="beam" [class.win]="solvedState" [attr.x1]="beamLeft.x" [attr.y1]="beamLeft.y" [attr.x2]="beamRight.x" [attr.y2]="beamRight.y" />
  <circle class="beam-end" [attr.cx]="beamLeft.x" [attr.cy]="beamLeft.y" r="7" />
  <circle class="beam-end" [attr.cx]="beamRight.x" [attr.cy]="beamRight.y" r="7" />
  <circle class="hub" [attr.cx]="PX" [attr.cy]="PY" r="16" />
  <circle class="hub-hi" [attr.cx]="PX - 4" [attr.cy]="PY - 5" r="5" />

  <!-- balance sparkle -->
  <text *ngIf="solvedState" class="eq" [attr.x]="PX" [attr.y]="PY - 40" text-anchor="middle">✦</text>

  <!-- ── Slider ────────────────────────────────────────────────────── -->
  <g class="slider">
    <line class="track" [attr.x1]="SX0" [attr.y1]="SLY" [attr.x2]="SX1" [attr.y2]="SLY" />
    <line class="track-fill" [attr.x1]="SX0" [attr.y1]="SLY" [attr.x2]="knobX" [attr.y2]="SLY" />
    <g [attr.transform]="'translate(' + knobX + ',' + SLY + ')'">
      <circle class="knob-glow" [class.win]="solvedState" r="21" />
      <rect class="knob" [class.win]="solvedState" x="-15" y="-15" width="30" height="30" rx="10" />
      <path class="knob-grip" d="M -5 -5 v 10 M 0 -6 v 12 M 5 -5 v 10" />
    </g>
  </g>
  <rect class="slider-drag" [attr.x]="SX0 - 30" [attr.y]="SLY - 34" [attr.width]="(SX1 - SX0) + 60" height="68"
        fill="transparent" (pointerdown)="onDown($event)" />
</svg>
